import { EXTERNAL_LOGIN_DOMAIN_WHITELIST } from 'shared/constants/externalLogin'
import { create } from 'zustand'

interface ExternalLoginStoreState {
  externalRedirect: string | null
  isExternal: boolean
}

interface ExternalLoginStoreActions {
  setExternalRedirect: (externalRedirect: string | null) => void
}

type ExternalLoginStore = ExternalLoginStoreState & ExternalLoginStoreActions

export const useExternalLoginStore = create<ExternalLoginStore>(set => ({
  externalRedirect: null,
  isExternal: false,
  setExternalRedirect: externalRedirect => {
    let isExternal = false

    if (externalRedirect) {
      const url = new URL(externalRedirect)
      const domain = url.hostname
      const isWhitelisted = EXTERNAL_LOGIN_DOMAIN_WHITELIST.some(
        whiteDomain =>
          domain === whiteDomain || domain.endsWith(`.${whiteDomain}`)
      )

      isExternal = isWhitelisted
    }

    set({ externalRedirect, isExternal })
  }
}))
